import styled from 'styled-components';

export const Container = styled.div`
  width: 310px;
  z-index: 2;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.darkBlue};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
`;
